---
date: 2022-09-02
title: Indoor taginfo
---

A taginfo instance, dedicated to indoor features (anything with a `level` tag) is available at: [taginfo.indoorequal.org](https://taginfo.indoorequal.org). The data will be updated monthly.
